import React, { useEffect, useRef } from "react";
import { OverPageCTA, OverPageCTAProps } from "./OverPageCTA";

interface ProductTipBannerProps extends OverPageCTAProps {
    onHeightChange?: (heightPx: number) => void;
}

export const ProductTipBanner: React.FC<ProductTipBannerProps> = ({
    onHeightChange,
    ...props
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!onHeightChange) {
            return;
        }

        const element = containerRef.current;
        if (!element) {
            return;
        }

        const updateHeight = () => {
            onHeightChange(Math.ceil(element.getBoundingClientRect().height));
        };

        updateHeight();

        const observer = new ResizeObserver(() => {
            updateHeight();
        });
        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [onHeightChange]);

    return (
        <div ref={containerRef}>
            <OverPageCTA {...props} />
        </div>
    );
};
